import React from "react";
import PropTypes from "prop-types";
import { GoogleMap, useLoadScript } from "@react-google-maps/api";
import { MapDiv } from "../styled";

const libraries = ["places"];

export const Map = ({ children, ...rest }) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries
  });

  let content;
  if (isLoaded) {
    content = (
      <GoogleMap
        mapContainerStyle={{
          width: "100%",
          height: "60vh"
        }}
        {...rest}
      >
        {children}
      </GoogleMap>
    );
  } else if (loadError) {
    content = <p>Map load error...</p>;
  } else {
    content = <p>Loading...</p>;
  }

  return <MapDiv>{content}</MapDiv>;
};

Map.propTypes = {
  children: PropTypes.node
};
